import type { UserProps } from '@img-arena/consoles-api-dde'
import { ddeApi } from '@/service/ddeApi'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchApi = async (
  args: FetchApiArgs<{ operatorId: number }, string, string>
): Promise<FetchApiResponse<UserProps>> => {
  const {
    signal,
    additionalParams: { operatorId }
  } = args

  const {
    data: { users }
  } = await ddeApi.endpoints.users.getAll(signal)

  const filteredUsers = users.filter((user) => user?.role?.operatorId === operatorId)

  return {
    content: filteredUsers,
    totalElements: filteredUsers.length
  }
}

export const useOperatorUsersStoreDDE = createBaseTableStore({
  storeName: 'DDE Operator Users',
  fetchApi
})
